document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {

        const target = e.target.closest('.js-modalLightbox');
        
        if(target === null) {
            return;
        }
            e.preventDefault();

            let modal_id = target.getAttribute('data-modal-src'),
                form = document.querySelector(modal_id),
                headerText = target.getAttribute('data-headertext'),
                imgSrc = target.getAttribute('data-imgsrc'),
                imgAltTitle = target.getAttribute('data-imgalttitle'),
                messageContent = target.getAttribute('data-messagecontent'),
                customMessage = target.getAttribute('data-custommessage'),
                titleContent = target.getAttribute('data-titlecontent'),
                formCategory = target.getAttribute('data-formcategory'),
                formName = target.getAttribute('data-formname'),
                postTitle = target.getAttribute('data-posttitle'),
                requestedService = target.getAttribute('data-requestedservice'),
                requestedServiceDetail = target.getAttribute('data-requestedservicedetail');

                if (formCategory !== 'undefined' && postTitle !== 'undefined') {
                    switch(formCategory) {

                        case 'Doctor':
                            titleContent = "<span class='c-contact__subtitle'>Get Help Contacting</span> " + postTitle;
                            messageContent = "I would like help getting in contact with " + postTitle + " and other mesothelioma specialists about my treatment options."
                            break;

                        case 'Center':
                            titleContent = "<span class='c-contact__subtitle'>Get Help Contacting</span> " + postTitle;
                            messageContent = "I would like help getting in contact with " + postTitle + " and other mesothelioma specialists about my treatment options."
                            break;

                        case 'ClinicalTrial':
                            titleContent = "<span class='c-contact__subtitle'>Get Help Enrolling in the</span> " + postTitle + " Clinical Trial";
                            messageContent = "I would like to learn more about " + postTitle + " and other clinical trials I may be qualified for."
                            break;

                        case 'LawFirm':
                            titleContent = "<span class='c-contact__subtitle'>Get Help Contacting</span> " + postTitle;
                            messageContent = "I would like help getting in contact with " + postTitle + " about my legal options.";
                            break;

                        default:
                            // code block
                            break;
                    }
                    
                    if(form){
                        let titleEl = form.querySelector('.c-form__title');

                        if (titleEl) {
                            titleEl.innerHTML = titleContent;    
                    }
                }
            }

            if (headerText !== null) {
                let titleEl = form.querySelector('.c-form__title');
                if (titleEl) {
                    titleEl.innerHTML = 'test';
                }
            }

            let diagnosisEl = form.querySelector("[name='diagnosis']");
            if (diagnosisEl && diagnosisEl.value !== null) {
                let optionEl = diagnosisEl.querySelector(`option[value='${diagnosisEl.value}']`);
                if (optionEl) {
                    optionEl.setAttribute('selected', 'selected');
                }
            }

            let reqServEl = form.querySelector("input[name='requested_service']");
            if (reqServEl && requestedService !== null) {
                reqServEl.value = requestedService;
            }

            let reqServDetailEl = form.querySelector("input[name='requested_service_detail']");
            if (reqServDetailEl && requestedServiceDetail !== null) {
                reqServDetailEl.value = requestedServiceDetail;
            }

            let formNameEl = form.querySelector("input[name='ga_form_name']");
            if (formNameEl && formName !== null) {
                formNameEl.value = formName;
            }

            if (customMessage === null) {
                customMessage = messageContent;
            }

            if (imgAltTitle === null) {
                imgAltTitle = postTitle;
            }

            let commentsEl = form.querySelector("[name='comments']");
            if (commentsEl) {
                commentsEl.value = customMessage;
            }

            if (imgAltTitle !== 'undefined') {
                let imgEl = form.querySelector('.c-form__image');
                if (imgEl) {
                    imgEl.setAttribute('title', imgAltTitle);
                    imgEl.setAttribute('src', imgSrc);
                    imgEl.setAttribute('alt', imgAltTitle);
                }
            }
        
    });
});